import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const state = () => ({
  categoriesStructure: null,
  cartCount:0
});

const actions = {
  async getCategoriesStructure({commit,state})
  {
    if (state.categoriesStructure)
    {
      return state.categoriesStructure;
    }
    let url = apiUrl + 'productCategory/getStructure';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data.categories)
    {
      commit("saveCarCategories", response.data.categories);
      return response.data.categories;
    }
  },
  async getCategory(c,id)
  {
    const url = apiUrl+'ProductCategory/get?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  /**
   *
   * @param c
   * @param params {brands,special,wonderful,countries,categories,car_part_id,
   * tags,providers,attributes,only_exists,begin_price,end_price,keyword}
   * @returns {Promise<any>}
   */
  async searchProduct(c,params)
  {
    const url = apiUrl+'shop/Product/search';
    const response = await jwtInterceptor.post(url,params);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getProduct(c,id)
  {
    const url = apiUrl+'shop/product/fullInfo?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getCategoryFilters(c,id)
  {
    const url = apiUrl+'category/getFilters?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  // async getSearchFilters(c)
  // {
  //   const url = apiUrl+'category/getFilters?id='+id;
  //   const response = await jwtInterceptor.get(url);
  //   if (response && response.data && response.data)
  //   {
  //     return response.data;
  //   }
  // },
  async addToCart(c,items)
  {
    const url = apiUrl+'ShopCart/add';
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getCartItems()
  {
    const url = apiUrl+'ShopCart/get';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async deleteCartItem(c,id)
  {
    const url = apiUrl+'ShopCart/deleteItem?id='+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getShippingItem()
  {
    const url = apiUrl+'ShopShipping/getShippingItems';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },async getOrder(c,id)
  {
    const url = apiUrl+'shopOrder/Get/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async payShopOrderByBalance(c,id)
  {
    const url = apiUrl+'shopOrder/payByBalance/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async submitDiscountCode(c,code)
  {
    const url = apiUrl+'shop/discountCode/Submit?code='+code;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async submitOrder(c,code)
  {
    let url = apiUrl+'shop/submitOrder';
    if (code)
      url += '?code='+code;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async cartItemChangeQuantity(c,{id,quantity})
  {
    const url = apiUrl+'ShopCart/changeQuantity?id='+id+'&quantity='+quantity;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async checkCartItems()
  {
    const url = apiUrl+'ShopCart/checkItems';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getPreOrders()
  {
    const url = apiUrl+'Shop/GetPreOrders';
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async getPreOrder(c,id)
  {
    const url = apiUrl+'Shop/GetPreOrderInfo/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async reRequestPreOrder(c,id)
  {
    const url = apiUrl+'Shop/PreOrder/ReRequest/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async preOrderCancel(c,id)
  {
    const url = apiUrl+'Shop/PreOrder/Cancel/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async deletePreOrder(c,id)
  {
    const url = apiUrl+'Shop/PreOrder/Delete/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async preOrderSubmit(c,{id,items})
  {
    const url = apiUrl+'Shop/PreOrder/Submit/'+id;
    const response = await jwtInterceptor.post(url,items);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async sendCustomerInvoice(c,orderId)
  {
    const url = apiUrl+'shop/order/sendCustomerInvoice/?order_id='+orderId;
    const response = await jwtInterceptor.post(url);
    if (response && response.data && response.data)
    {
      return response.data;
    }
  },
  async setCartCount({commit},n)
  {
    commit("saveCartCount", n);
  }


};


const mutations = {
  saveCarCategories(state, status)
  {
    state.categoriesStructure = status;
  },
  saveCartCount(state,n)
  {
    state.cartCount = n;
  }
};

const getters = {
  getCategoriesStructure(state)
  {
    return state.categoriesStructure;
  },
  getCartCount(state)
  {
    return state.cartCount;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations:mutations
}